import cn from 'classnames'
import styles from './chip.module.scss'

/**
 * @param {{
 *   variant?: 'lime'|'mint'|'sage'|'tan'|'warn'|'alert',
 *   children: React.ReactNode,
 *   className?: string,
 *   ariaLabel?: string
 * }} props
 */
export function Chip({variant = 'sage', children, className, ariaLabel}) {
    return (
        <span
            className={cn(styles.chip, styles[variant], className)}
            aria-label={ariaLabel}
        >
            {children}
        </span>
    )
}
